import React from "react";
import { Tag } from "antd";
import { getPermissionName, PERMISSION_ORDER, SUB_ACCOUNT_PERMISSION_ORDER } from "../../utils/permission";
import styles from "./index.modules.less";

const PermissionTagGroup = ({ permissions = [], showUnauthorized = false, scope }) => {
  const normalized = Array.isArray(permissions) ? permissions : [];
  const scopeOrder = scope === "sub_account" ? SUB_ACCOUNT_PERMISSION_ORDER : PERMISSION_ORDER;

  const renderPermissions = showUnauthorized
    ? normalized.filter((code) => scopeOrder.includes(code))
    : normalized.filter((code) => scopeOrder.includes(code));

  if (renderPermissions.length === 0) {
    return <span>{showUnauthorized ? "无" : "未授权任何模块"}</span>;
  }

  return (
    <>
      {renderPermissions.map((code) => (
        <Tag key={code} color={showUnauthorized ? "default" : "processing"} className={showUnauthorized ? styles.tagUnauthorized : undefined}>
          {getPermissionName(code)}
        </Tag>
      ))}
    </>
  );
};

export default PermissionTagGroup;
